/*!
 * vue-auth-plugin v1.8.2 
 * (c) 2020 d0whc3r
 * Released under the MIT License.
 */
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var AuthVueRouter = /*#__PURE__*/function () {
  function AuthVueRouter(Vue, options, storeManager) {
    _classCallCheck(this, AuthVueRouter);

    this.Vue = Vue;
    this.options = options;
    this.storeManager = storeManager;

    if (!this.Vue.router) {
      throw Error('[vue-auth-plugin] vue-router is a required dependency');
    }

    this.router = Vue.router;
    this.configureRouter();
  }

  _createClass(AuthVueRouter, [{
    key: "push",
    value: function () {
      var _push = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(to) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.router.push(to);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function push(_x) {
        return _push.apply(this, arguments);
      }

      return push;
    }()
  }, {
    key: "afterLogin",
    value: function () {
      var _afterLogin = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(redirect) {
        var _this = this;

        var promise, nextUrl;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                promise = Promise.resolve(undefined);

                if (redirect) {
                  promise = this.router.push(redirect);
                } else if (this.router.currentRoute.query.nextUrl) {
                  nextUrl = this.router.currentRoute.query.nextUrl;

                  if (typeof nextUrl === 'string') {
                    promise = this.router.push(nextUrl);
                  }
                } else {
                  promise = this.router.push('/');
                }

                if (promise) {
                  promise.catch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
                    var result;
                    return regenerator.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            result = redirect || '/';
                            _context2.next = 3;
                            return _this.router.push(result);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })));
                }

                return _context3.abrupt("return", promise);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function afterLogin(_x2) {
        return _afterLogin.apply(this, arguments);
      }

      return afterLogin;
    }()
  }, {
    key: "configureRouter",
    value: function configureRouter() {
      var _this2 = this;

      this.router.beforeEach(function (to, from, next) {
        var _this2$options = _this2.options,
            authRedirect = _this2$options.authRedirect,
            loginData = _this2$options.loginData;

        var routes = _this2.metaRoutes(to);

        if (routes && routes.length) {
          if (_this2.isAuthorized(routes)) {
            next();
          } else {
            var redirectPath = {
              path: authRedirect || '/'
            };

            if (loginData && !loginData.redirect) {
              redirectPath.query = {
                nextUrl: to.fullPath
              };
            }

            var nextPath = from.fullPath !== to.fullPath && _this2.storeManager.check() ? from.fullPath : redirectPath;
            next(nextPath);
          }
        } else {
          next();
        }
      });
    }
  }, {
    key: "isAuthorized",
    value: function isAuthorized(routes) {
      var _this3 = this;

      var token = this.storeManager.getToken();
      var isAuth = false;
      routes.forEach(function (route) {
        var auth = _this3.options.authMeta && route.meta[_this3.options.authMeta];

        if (typeof auth === 'boolean') {
          isAuth = !!token;
        } else if (typeof auth === 'string' || Array.isArray(auth)) {
          isAuth = _this3.storeManager.check(auth);
        }
      });
      return isAuth;
    }
  }, {
    key: "metaRoutes",
    value: function metaRoutes(to) {
      var _this4 = this;

      return to.matched.filter(function (url) {
        return url.path !== _this4.options.authRedirect;
      }).filter(function (match) {
        return _this4.options.authMeta && match.meta.hasOwnProperty(_this4.options.authMeta);
      }).filter(function (meta) {
        return !!meta;
      });
    }
  }]);

  return AuthVueRouter;
}();

var VueAuthStore = /*#__PURE__*/function () {
  function VueAuthStore(Vue, options) {
    _classCallCheck(this, VueAuthStore);

    this.Vue = Vue;
    this.options = options;
  }

  _createClass(VueAuthStore, [{
    key: "initVue",
    value: function initVue() {
      var token = this.getToken();

      if (token) {
        this.options.Vue.$data.token = token;
      }

      var user = this.getUser();

      if (user) {
        this.options.Vue.$data.user = user;
      }
    }
  }]);

  return VueAuthStore;
}();

var StoreCookie = /*#__PURE__*/function (_VueAuthStore) {
  _inherits(StoreCookie, _VueAuthStore);

  var _super = _createSuper(StoreCookie);

  function StoreCookie(Vue, options) {
    var _this;

    _classCallCheck(this, StoreCookie);

    _this = _super.call(this, Vue, options);
    _this.documentCookie = false;
    _this.enabled = true;

    try {
      if (_this.Vue.cookie) {
        _this.store = _this.Vue.cookie;
      } else if (typeof document.cookie === 'string') {
        _this.documentCookie = true;
      }
    } catch (_) {
      console.warn('[vue-auth-plugin]: Cookie store not enabled');
      _this.enabled = false;
    }

    _this.initVue();

    return _this;
  }

  _createClass(StoreCookie, [{
    key: "getRoles",
    value: function getRoles() {
      var user = this.getUser();
      return user && this.options.rolesVar && user[this.options.rolesVar];
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.getCookie(this.options.tokenDefaultName);
    }
  }, {
    key: "getUser",
    value: function getUser() {
      return this.getCookie(this.options.userDefaultName);
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      if (token) {
        this.setCookie(this.options.tokenDefaultName, token);
      } else {
        this.deleteCookie(this.options.tokenDefaultName);
      }
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      if (user && Object.keys(user).length) {
        this.setCookie(this.options.userDefaultName, user);
      } else {
        this.deleteCookie(this.options.userDefaultName);
      }
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      if (!name || !this.enabled) {
        return;
      }

      var result;

      if (!this.documentCookie) {
        result = this.store.get(name);
      } else {
        var cookiePair = document.cookie.replace(/;\s+/g, ';').split(';').map(function (str) {
          return str.replace(/\s+=\s+/g, '=').split('=');
        }).filter(function (cookiePair) {
          return cookiePair[0] === name;
        }).pop() || [];
        result = cookiePair[1] || null;
      }

      try {
        return JSON.parse(result);
      } catch (_) {
        return result;
      }
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value) {
      if (!name || !this.enabled) {
        return;
      }

      value = JSON.stringify(value);

      if (!this.documentCookie) {
        this.store.set(name, value);
      } else {
        document.cookie = "".concat(name, "=").concat(value);
      }
    }
  }, {
    key: "deleteCookie",
    value: function deleteCookie(name) {
      if (!name || !this.enabled) {
        return;
      }

      if (!this.documentCookie) {
        this.store.delete(name);
      } else {
        document.cookie = "".concat(name, "=");
      }
    }
  }]);

  return StoreCookie;
}(VueAuthStore);

var StoreLocalStorage = /*#__PURE__*/function (_VueAuthStore) {
  _inherits(StoreLocalStorage, _VueAuthStore);

  var _super = _createSuper(StoreLocalStorage);

  function StoreLocalStorage(Vue, options) {
    var _this;

    _classCallCheck(this, StoreLocalStorage);

    _this = _super.call(this, Vue, options);
    _this.store = window.localStorage;

    _this.initVue();

    return _this;
  }

  _createClass(StoreLocalStorage, [{
    key: "getRoles",
    value: function getRoles() {
      var user = this.getUser();
      return user && this.options.rolesVar && user[this.options.rolesVar];
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.store.getItem(this.options.tokenDefaultName);
    }
  }, {
    key: "getUser",
    value: function getUser() {
      return JSON.parse(this.store.getItem(this.options.userDefaultName));
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      if (token) {
        this.store.setItem(this.options.tokenDefaultName, token);
      } else {
        this.store.removeItem(this.options.tokenDefaultName);
      }
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      if (user && Object.keys(user)) {
        this.store.setItem(this.options.userDefaultName, JSON.stringify(user));
      } else {
        this.store.removeItem(this.options.userDefaultName);
      }
    }
  }]);

  return StoreLocalStorage;
}(VueAuthStore);

var StoreSessionStorage = /*#__PURE__*/function (_StoreLocalStorage) {
  _inherits(StoreSessionStorage, _StoreLocalStorage);

  var _super = _createSuper(StoreSessionStorage);

  function StoreSessionStorage(Vue, options) {
    var _this;

    _classCallCheck(this, StoreSessionStorage);

    _this = _super.call(this, Vue, options);
    _this.Vue = Vue;
    _this.options = options;
    _this.store = window.sessionStorage;

    _this.initVue();

    return _this;
  }

  return StoreSessionStorage;
}(StoreLocalStorage);

var StoreVuex = /*#__PURE__*/function (_VueAuthStore) {
  _inherits(StoreVuex, _VueAuthStore);

  var _super = _createSuper(StoreVuex);

  function StoreVuex(Vue, options) {
    var _this;

    _classCallCheck(this, StoreVuex);

    _this = _super.call(this, Vue, options);
    _this.ACTION_SET_TOKEN = 'SET_TOKEN';
    _this.ACTION_SET_USER = 'SET_USER';

    if (!_this.Vue.store) {
      throw Error('[vue-auth-plugin] vuex is a required dependency if you want to use "vuex" as storage');
    }

    _this.store = _this.Vue.store;
    _this.module = _this.options.vuexStoreSpace;

    _this.createVueAuthStore();

    _this.initVue();

    return _this;
  }

  _createClass(StoreVuex, [{
    key: "getRoles",
    value: function getRoles() {
      var _this$store$getters;

      return (_this$store$getters = this.store.getters) === null || _this$store$getters === void 0 ? void 0 : _this$store$getters["".concat(this.module, "/getRoles")];
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this$store$getters2;

      return (_this$store$getters2 = this.store.getters) === null || _this$store$getters2 === void 0 ? void 0 : _this$store$getters2["".concat(this.module, "/getToken")];
    }
  }, {
    key: "getUser",
    value: function getUser() {
      var _this$store$getters3;

      return (_this$store$getters3 = this.store.getters) === null || _this$store$getters3 === void 0 ? void 0 : _this$store$getters3["".concat(this.module, "/getUser")];
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.store.dispatch("".concat(this.module, "/setToken"), token);
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      this.store.dispatch("".concat(this.module, "/setUser"), user);
    }
  }, {
    key: "createVueAuthStore",
    value: function createVueAuthStore() {
      var _this2 = this;

      var rolesVar = this.options.rolesVar;
      var module = {
        namespaced: true,
        state: {
          token: this.options.Vue.$data.token,
          user: this.options.Vue.$data.user
        },
        mutations: {
          SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
          },
          SET_USER: function SET_USER(state, user) {
            state.user = user;
          }
        },
        actions: {
          setToken: function setToken(actionContext, token) {
            actionContext.commit(_this2.ACTION_SET_TOKEN, token);
          },
          setUser: function setUser(actionContext, user) {
            actionContext.commit(_this2.ACTION_SET_USER, user);
          }
        },
        getters: {
          getToken: function getToken(state) {
            return state.token;
          },
          getUser: function getUser(state) {
            return state.user;
          },
          getRoles: function getRoles(state) {
            var user = state.user;
            return user && rolesVar && user[rolesVar];
          }
        }
      };

      if (this.module) {
        this.store.registerModule(this.module, module);
      } // Listen for mutation from outside, e.g. with vuex-shared-mutations


      this.store.subscribe(function (mutation) {
        var payload = mutation.payload,
            type = mutation.type;

        if (type === "".concat(_this2.module, "/").concat(_this2.ACTION_SET_TOKEN) && payload !== _this2.options.Vue.$data.token) {
          _this2.options.Vue.$data.token = payload;
        } else if (type === "".concat(_this2.module, "/").concat(_this2.ACTION_SET_USER) && payload !== _this2.options.Vue.$data.user) {
          _this2.options.Vue.$data.user = payload;
        }
      });
    }
  }]);

  return StoreVuex;
}(VueAuthStore);

var AuthStoreManager = /*#__PURE__*/function (_VueAuthStore) {
  _inherits(AuthStoreManager, _VueAuthStore);

  var _super = _createSuper(AuthStoreManager);

  function AuthStoreManager(Vue, options) {
    var _this;

    _classCallCheck(this, AuthStoreManager);

    _this = _super.call(this, Vue, options);

    _this.setStores();

    _this.options.Vue.$watch('user', function (value) {
      _this.setUser(value);
    });

    _this.options.Vue.$watch('token', function (value) {
      _this.setToken(value);
    });

    return _this;
  }

  _createClass(AuthStoreManager, [{
    key: "setStores",
    value: function setStores() {
      var _this2 = this;

      this.stores = Object.assign([], this.options.tokenStore).map(function (store) {
        switch (store) {
          case 'cookie':
            var cookieStore = new StoreCookie(_this2.Vue, _this2.options);
            return cookieStore.enabled ? cookieStore : null;

          case 'sessionStorage':
            return new StoreSessionStorage(_this2.Vue, _this2.options);

          case 'vuex':
            return new StoreVuex(_this2.Vue, _this2.options);

          default:
            return new StoreLocalStorage(_this2.Vue, _this2.options);
        }
      }).filter(function (store) {
        return !!store;
      });
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      return this.allStores.map(function (store) {
        return store.getRoles();
      }).filter(function (roles) {
        return roles && roles.length;
      })[0];
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var token = this.allStores.map(function (store) {
        return store.getToken();
      }).filter(function (token) {
        return !!token;
      })[0];
      return token || this.options.Vue.$data.token;
    }
  }, {
    key: "getUser",
    value: function getUser() {
      var user = this.allStores.map(function (store) {
        return store.getUser();
      }).filter(function (user) {
        return !!user;
      })[0];
      return user || this.options.Vue.$data.user;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.options.Vue.$data.token = token;
      this.allStores.forEach(function (store) {
        store.setToken(token);
      });
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      this.options.Vue.$data.user = user;
      this.allStores.forEach(function (store) {
        store.setUser(user);
      });
    }
  }, {
    key: "resetAll",
    value: function resetAll() {
      this.options.Vue.$data.user = null;
      this.options.Vue.$data.token = null;
      this.setUser(null);
      this.setToken(null);
    }
  }, {
    key: "check",
    value: function check(role) {
      if (role) {
        var roles = this.getRoles();

        if (!roles) {
          return false;
        }

        if (Array.isArray(role)) {
          return roles.some(function (authrole) {
            return role.includes(authrole);
          });
        } else {
          return roles.includes(role);
        }
      } else {
        return !!this.getToken();
      }
    }
  }, {
    key: "allStores",
    get: function get() {
      return _toConsumableArray(this.stores || []);
    }
  }]);

  return AuthStoreManager;
}(VueAuthStore);

var AuthVueHttp = /*#__PURE__*/function () {
  function AuthVueHttp(Vue, options, storeManager, router) {
    _classCallCheck(this, AuthVueHttp);

    this.Vue = Vue;
    this.options = options;
    this.storeManager = storeManager;
    this.router = router;
    this.MINUTE_IN_MS = 60 * 1000;

    if (!this.Vue.axios) {
      throw Error('[vue-auth-plugin] vue-axios is a required dependency');
    }

    this.http = Vue.axios;
    this.configureHttp();
  }

  _createClass(AuthVueHttp, [{
    key: "login",
    value: function login(loginInfo) {
      var _this = this;

      if (!this.options.loginData) {
        console.warn('[vue-auth-plugin] Login not configured, use "loginData" option');
        return Promise.reject(false);
      }

      var nextUrls = this.router.router.currentRoute.query.nextUrl;
      var nextUrl = Array.isArray(nextUrls) ? nextUrls[0] : nextUrls;
      var _this$options$loginDa = this.options.loginData,
          method = _this$options$loginDa.method,
          url = _this$options$loginDa.url,
          redirect = _this$options$loginDa.redirect,
          fetchUser = _this$options$loginDa.fetchUser,
          fetchData = _this$options$loginDa.fetchData;
      var promise = this.http({
        method: method,
        url: url,
        data: loginInfo
      });
      promise.then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(response) {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.extractToken(response);

                  _this.startIntervals();

                  if (!fetchData) {
                    _context.next = 6;
                    break;
                  }

                  _this.storeManager.setUser(fetchData.call({}, response));

                  _context.next = 9;
                  break;

                case 6:
                  if (!fetchUser) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 9;
                  return _this.fetchData(true);

                case 9:
                  _context.next = 11;
                  return _this.router.afterLogin(redirect || nextUrl);

                case 11:
                  return _context.abrupt("return", response);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.warn('[vue-auth-plugin] Login error', error.message);
      });
      return promise;
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this2 = this;

      var forceRedirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var logout = this.options.logoutData && _typeof(this.options.logoutData) === 'object' && Object.keys(this.options.logoutData).length ? this.options.logoutData : {};
      var url = logout.url,
          method = logout.method,
          redirect = logout.redirect,
          makeRequest = logout.makeRequest;

      if (makeRequest) {
        this.http({
          method: method,
          url: url,
          headers: _objectSpread2({}, this.getAuthHeader())
        }).finally(function () {
          _this2.storeManager.resetAll();

          if (redirect || forceRedirect) {
            _this2.router.push(redirect || '/');
          }
        });
      }

      if (this.intervalFetchData) {
        clearInterval(this.intervalFetchData);
      }

      this.storeManager.resetAll();

      if (redirect || forceRedirect) {
        this.router.push(redirect || '/');
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this3 = this;

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var fetch = this.options.fetchData && _typeof(this.options.fetchData) === 'object' && Object.keys(this.options.fetchData).length ? this.options.fetchData : {};
      var enabled = fetch.enabled,
          method = fetch.method,
          url = fetch.url;

      if ((enabled || force) && url && method && this.storeManager.getToken()) {
        var promise = this.http({
          method: method,
          url: url,
          headers: _objectSpread2({}, this.getAuthHeader())
        });
        promise.then(function (_ref2) {
          var data = _ref2.data;
          var fetchItem = _this3.options.fetchItem;

          _this3.storeManager.setUser(fetchItem ? data[fetchItem] : data);

          return data;
        }).catch(function (error) {
          console.warn('[vue-auth-plugin] Fetching user error', error.message);
        });
        return promise;
      }

      return Promise.resolve(null);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this4 = this;

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var refresh = this.options.refreshData && _typeof(this.options.refreshData) === 'object' && Object.keys(this.options.refreshData).length ? this.options.refreshData : {};
      var enabled = refresh.enabled,
          method = refresh.method,
          url = refresh.url;

      if ((enabled || force) && url && method && this.storeManager.getToken()) {
        var promise = this.http({
          method: method,
          url: url,
          headers: _objectSpread2({}, this.getAuthHeader())
        });
        promise.then( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(response) {
            return regenerator.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this4.extractToken(response);

                    return _context2.abrupt("return", response);

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(function (error) {
          console.warn('[vue-auth-plugin] Refresh error', error.message);
        });
        return promise;
      }

      return Promise.resolve(null);
    }
  }, {
    key: "configureHttp",
    value: function configureHttp() {
      var _this5 = this;

      var token = this.storeManager.getToken();

      if (!!token) {
        this.startIntervals();
      }

      this.http.interceptors.request.use(function (request) {
        if (request.headers) {
          Object.keys(request.headers).forEach(function (head) {
            var value = request.headers[head];

            if (value && typeof value === 'string' && _this5.options.headerTokenReplace && value.includes(_this5.options.headerTokenReplace)) {
              request.headers[head] = value.replace(_this5.options.headerTokenReplace, _this5.storeManager.getToken());
            }
          });
        }

        return request;
      }, function (error) {
        return Promise.reject(error);
      });
      this.http.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        var status = error && error.response && error.response.status;

        if (status === 401) {
          _this5.logout();
        }

        return Promise.reject(error);
      });
    }
  }, {
    key: "startIntervals",
    value: function startIntervals() {
      this.startFetchDataInterval();
      this.startRefreshDataInterval();
    }
  }, {
    key: "startFetchDataInterval",
    value: function startFetchDataInterval() {
      var _this6 = this;

      if (!this.options.fetchData) {
        return;
      }

      var interval = this.options.fetchData.interval;

      if (interval && !this.intervalFetchData) {
        this.intervalFetchData = setInterval(function () {
          _this6.fetchData();
        }, interval * this.MINUTE_IN_MS);
      }
    }
  }, {
    key: "startRefreshDataInterval",
    value: function startRefreshDataInterval() {
      var _this7 = this;

      if (!this.options.refreshData) {
        return;
      }

      var interval = this.options.refreshData.interval;

      if (interval && !this.intervalRefreshData) {
        this.intervalRefreshData = setInterval(function () {
          _this7.refresh();
        }, interval * this.MINUTE_IN_MS);
      }
    }
  }, {
    key: "extractToken",
    value: function extractToken(response) {
      if (!this.options.loginData) {
        return;
      }

      var token = '';
      var _this$options$loginDa2 = this.options.loginData,
          headerToken = _this$options$loginDa2.headerToken,
          customToken = _this$options$loginDa2.customToken;

      if (customToken) {
        token = customToken(response);
      } else if (headerToken) {
        var head = (response.headers[headerToken.toLowerCase()] || '').split(' ');
        token = head[1] || head[0];
      }

      if (!token) {
        console.error('[vue-auth-plugin] No token is obtained');
      } else {
        this.storeManager.setToken(token.trim());
      }
    }
  }, {
    key: "getAuthHeader",
    value: function getAuthHeader() {
      if (this.options.loginData) {
        var headerToken = this.options.loginData.headerToken;
        var _this$options = this.options,
            tokenType = _this$options.tokenType,
            headerTokenReplace = _this$options.headerTokenReplace;
        var token = "".concat(tokenType, " ").concat(headerTokenReplace).trim();
        return _defineProperty({}, headerToken, token);
      }

      console.error('[vue-auth-plugin] No "loginData" is defined');
      return {};
    }
  }]);

  return AuthVueHttp;
}();

var DEFAULT_OPTIONS = {
  authMeta: 'auth',
  rolesVar: 'roles',
  tokenDefaultName: 'default_auth_token',
  userDefaultName: 'default_auth_user',
  tokenStore: ['vuex', 'localStorage', 'cookie'],
  headerTokenReplace: '{auth_token}',
  tokenType: 'Bearer',
  vuexStoreSpace: 'vue-auth',
  authRedirect: '/login',
  loginData: {
    url: '/auth/login',
    method: 'POST',
    redirect: '/',
    headerToken: 'Authorization',
    fetchUser: false
  },
  logoutData: {
    url: '/auth/logout',
    method: 'POST',
    redirect: '/login',
    makeRequest: false
  },
  fetchItem: '',
  fetchData: {
    url: '/auth/user',
    method: 'GET',
    interval: 30,
    enabled: false
  },
  refreshData: {
    url: '/auth/refresh',
    method: 'GET',
    interval: 30,
    enabled: false
  }
};

var Auth = /*#__PURE__*/function () {
  function Auth(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Auth);

    this.Vue = Vue;
    this.options = {};
    this.options = _objectSpread2({}, DEFAULT_OPTIONS, {}, options, {
      Vue: new this.Vue({
        data: function data() {
          return {
            user: null,
            token: null
          };
        }
      })
    });
    this.storeManager = new AuthStoreManager(this.Vue, this.options);
    var router = new AuthVueRouter(this.Vue, this.options, this.storeManager);
    this.http = new AuthVueHttp(this.Vue, this.options, this.storeManager, router);
  }

  _createClass(Auth, [{
    key: "login",
    value: function login(loginInfo) {
      return this.http.login(loginInfo);
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.http.logout();
    }
  }, {
    key: "check",
    value: function check(role) {
      return this.storeManager.check(role);
    }
  }, {
    key: "user",
    value: function user() {
      return this.storeManager.getUser();
    }
  }, {
    key: "roles",
    value: function roles() {
      return this.storeManager.getRoles();
    }
  }, {
    key: "token",
    value: function token() {
      return this.storeManager.getToken();
    }
  }, {
    key: "fetchUser",
    value: function fetchUser() {
      return this.http.fetchData(true);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      return this.http.refresh(true);
    }
  }]);

  return Auth;
}();

var version = '1.8.2';

var install = function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (plugin.installed) {
    return;
  }

  plugin.installed = true;
  var auth = new Auth(Vue, options);
  Vue.$auth = auth;
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: function get() {
        return auth;
      }
    }
  });
};

var plugin = {
  install: install,
  version: version
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin, {});
}

export default plugin;
export { DEFAULT_OPTIONS, VueAuthStore };
